import { connect } from 'react-redux'
import PromoCode from './PromoCode'

const mapStateToProps = () => ({})

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(PromoCode)
